/* eslint-disable max-len */
const ArrowRightDownIcon = ({ className = '' }) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M32 3.04451L29.1583 3.04451L29.1583 27.1085L1.98683 -1.32968e-06L1.81801e-06 2.07152L27.0957 29.1028L3.02879 29.1028L3.02879 32L32 32L32 3.04451Z" fill="currentColor" />
  </svg>
);

export default ArrowRightDownIcon;
